import React, { useEffect, useState } from 'react';
// import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Pagination from 'components/Pagination';
import ToggleSwitch from '../../../components/ToggleSwitch/ToggleSwitch';
import MultiButtonsHeader from '../../../components/Headers/MultiButtons';
import { verifyRoles } from 'components/Authentication/VerifyRoles';
import UserService from '../service';
import ModalConfirmationCopyUser from '../form/components/ModalConfirmationCopyUser';

import {
  Input,
  Container,
  Row,
  Card,
  CardHeader,
  Button,
  CardBody,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Label
} from 'reactstrap';

import {
  select_field_row_style,
  icon_column_style,
  individual_column_style,
  individual_icon_header_style,
  individual_header_style
} from '../../../assets/styles/table_custom_style';
import ReactLoader from 'components/Loader';
import ManageQueuesModal from '../form/components/ManageQueuesModal';

const UserList = () => {
  const history = useHistory();

  const [login, setLogin] = useState('');
  const [users, setUsers] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchUsers, setSearchUsers] = useState();
  const [showDisabled, setShowDisable] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const [showQueuesModal, setShowQueuesModal] = useState(false);
  const [usersForQueues, setUsersForQueues] = useState([]);
  const [queues, setQueues] = useState([]);

  const [openCloneModal, setOpenCloneModal] = useState(false);
  const [userToCopy, setUserToCopy] = useState(null);
  const [isCloning, setIsCloning] = useState(false);
  const [isFetchingCopy, setIsFetchingCopy] = useState(false);
  const [sortField, setSortField] = useState('name');
  const [sortOrder, setSortOrder] = useState('asc');

  useEffect(() => {
    setLogin(localStorage.getItem('login'));
  }, []);

  useEffect(() => {
    getUsers();
  }, [sortField, sortOrder]);

  const getUsers = (selectedPage = 1, search = '') => {
    setLoading(true);
    UserService.getAllSeachUser(
      selectedPage,
      10,
      search,
      showDisabled,
      login,
      sortField,
      sortOrder,
      'contexto'
    )
      .then((response) => {
        const userList = response.data.data;
        const quantity = response.data.totalRegisters;
        setUsers(userList);
        setQuantity(quantity);
        setLoading(false);
        setActivePage(selectedPage);
      })
      .catch((err) => {
        toast.error(err.response.data.message || 'Erro ao listar usuários!', {
          autoClose: 3000,
          closeOnClick: true
        });
        setLoading(false);
      });
  };

  useEffect(getUsers, [showDisabled]);

  const openQueuesModal = () => {
    UserService.usersForQueues(login)
      .then((response) => {
        const users = response?.data?.data || [];
        setUsersForQueues(users);
        const currentUser = users.find((u) => u.login === login);
        setQueues(currentUser?.queues || []);
        setShowQueuesModal(true);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || 'Erro ao listar usuários!', {
          autoClose: 3000,
          closeOnClick: true
        });
        setLoading(false);
      });
  };

  const navigateToEditMultiple = () => {
    // O botão 'Editar todos' foi clicado
    if (selectedRows.length < 2) {
      return history.push(`user/form/edit_multiple`, {
        actionType: 'EDIT_ALL'
      });
    }
    const verifier = selectedRows[0];
    const isValid = selectedRows.every((id) => id.type === verifier.type);
    if (isValid) {
      return history.push('/admin/user/form/edit_multiple', {
        actionType: 'EDIT_MULTIPLE',
        users: selectedRows
      });
    } else {
      toast.error('Os ramais devem ser do mesmo tipo', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };
  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      const newSelected = { id: row.login };
      setSelectedRows([...selectedRows, newSelected]);
    } else {
      setSelectedRows(selectedRows.filter((x) => x.id !== row.login));
    }
  };
  const handleOnSelectAll = (isSelect, rows) => {
    const allRows = rows.map((r) => {
      return { id: r.login };
    });
    if (isSelect) {
      setSelectedRows(allRows);
    } else {
      setSelectedRows([]);
    }
  };

  const changeActive = (login, active) => {
    if (active) {
      if (!window.confirm('Tem certeza que deseja desabilitar o usuário?'))
        return;
    }
    UserService.changeActive(login, { active: !active })
      .then(() => {
        toast.info(
          !active
            ? 'Usuário habilitado com sucesso!'
            : 'Usuário desabilitado com sucesso!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
        if (!showDisabled && active === true) {
          setUsers((prevUsers) => prevUsers.filter((u) => u.login !== login));
          setQuantity((prev) => (prev > 0 ? prev - 1 : 0));
        } else {
          setUsers((prevUsers) =>
            prevUsers.map((u) =>
              u.login === login ? { ...u, active: !active } : u
            )
          );
        }
      })
      .catch((err) => {
        toast.error(err.response.data.message || 'Ops algo errado aconteceu!', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const getUsersSearch = (event, selectedPage = 1) => {
    const value = event.target.value;
    setSearchUsers(value);
    if (value || value === '') {
      getUsers(selectedPage, value);
    }
  };

  const handlePageChange = (page) => {
    setActivePage(page);
    getUsers(page, searchUsers);
  };

  const renderButtonsOnHeader = () => {
    const buttons = [];
    const canEdit = verifyRoles(['USERS_EDIT']);
    const canManageQueues = verifyRoles(['MANAGE_QUEUES']);

    if (canManageQueues) {
      buttons.push({
        label: 'Gerenciar Filas',
        customNavigator: openQueuesModal
      });
    }
    if (canEdit) {
      buttons.push(
        {
          label: 'Editar vários',
          customNavigator: navigateToEditMultiple,
          disabled: selectedRows.length < 2
        },
        {
          label: 'Editar todos',
          customNavigator: navigateToEditMultiple
        }
      );
    }
    return buttons;
  };

  const buildCreatePayloadFromUser = (originalUser, overrides) => {
    const rawType = originalUser?.type_of_redistribution;
    const type_of_redistribution =
      typeof rawType === 'string' ? rawType : rawType?.value ?? 'current_queue';

    const profileId = originalUser?.profileId ?? null;
    const context = originalUser?.context ?? null;
    const teamId = originalUser?.teamId ?? null;

    const recordtypesid = (originalUser?.recordTypes ?? [])
      .map((rt) => (typeof rt === 'object' ? rt.id : rt))
      .filter(Boolean);

    const costscenterid = (originalUser?.costscenter ?? [])
      .map((cc) => (typeof cc === 'object' ? cc.id : cc))
      .filter(Boolean);

    const costCenterId = originalUser?.costCenterId ?? null;

    const extensionsid = (originalUser?.extensions ?? [])
      .map((ex) => (typeof ex === 'object' ? ex.extension_number : ex))
      .filter(Boolean);

    const webrtcextensionsid = (originalUser?.webrtcExtensions ?? [])
      .map((ex) => (typeof ex === 'object' ? ex.extension_number : ex))
      .filter(Boolean);

    const queuesid = (originalUser?.queues ?? [])
      .map((q) => (typeof q === 'object' ? q.id : q))
      .filter(Boolean);

    const queues_telephone = (originalUser?.queueTelephony ?? [])
      .map((q) => (typeof q === 'object' ? q.id : q))
      .filter(Boolean);

    const profilesid = (originalUser?.profiles ?? [])
      .map((p) => (typeof p === 'object' ? p.id : p))
      .filter(Boolean);

    const teamsIds = (originalUser?.teams ?? [])
      .map((t) => (typeof t === 'object' ? t.id : t))
      .filter(Boolean);

    const supervisorids = (originalUser?.supervisors ?? [])
      .map((ex) => (typeof ex === 'object' ? ex.login : ex))
      .filter(Boolean);

    const isSupervisor = !!originalUser?.isSupervisor;

    const ringgroupids = (originalUser?.ringGroups ?? [])
      .map((rg) => (typeof rg === 'object' ? rg.id : rg?.value ?? rg))
      .filter(Boolean);

    const show_all_conversations = !!originalUser?.show_all_conversations;
    const show_all_protocols = !!originalUser?.show_all_protocols;
    const show_all_leads = !!originalUser?.show_all_leads;
    const show_all_opportunities = !!originalUser?.show_all_opportunities;
    const show_all_accounts = !!originalUser?.show_all_accounts;
    const webrtc_auto_login = !!originalUser?.webrtc_auto_login;

    const isAutomaticLoginQueueChat = !!originalUser?.isAutomaticLoginQueueChat;
    const redistribute_when_logout_of_queues =
      !!originalUser?.redistribute_when_logout_of_queues;

    const max_chats_in_attendance = originalUser?.max_chats_in_attendance ?? 0;

    const signatureEmail = {
      active: !!originalUser?.signatureEmail?.active,
      signature: originalUser?.signatureEmail?.signature || ''
    };

    const isAbleToEditSlaInfoMoreThanOnce =
      !!originalUser?.isAbleToEditSlaInfoMoreThanOnce;

    const queuesidToSignIn = (originalUser?.queuesidToSignIn ?? [])
      .map((q) => (typeof q === 'object' ? q.id : q))
      .filter(Boolean);

    const queuesIdToSignInChat = (originalUser?.queuesIdToSignInChat ?? [])
      .map((q) => (typeof q === 'object' ? q.id : q))
      .filter(Boolean);

    const penalties = (originalUser?.penalties ?? [])
      .map((p) => {
        if (typeof p === 'object' && p.queue_id !== undefined) {
          return {
            queue_id: p.queue_id,
            penalty: p.penalty ?? 0
          };
        }
        return null;
      })
      .filter(Boolean);

    const scaleId = originalUser?.scaleId ?? originalUser?.scale?.id ?? null;

    const should_sign_in_asterisk =
      !!originalUser?.should_sign_in_asterisk ||
      queuesidToSignIn.length > 0 ||
      !!scaleId;

    const payload = {
      login: overrides.login?.trim(),
      name: overrides.name?.trim(),
      password: overrides.password,
      agent_code: overrides.agent_code,
      integration_login: overrides.integration_login || '',
      integration_password: overrides.integration_password || '',
      email: originalUser?.email || '',
      telephone: originalUser?.telephone || '',
      profileId,
      context,
      teamId,
      recordtypesid,
      costscenterid,
      costCenterId,
      extensionsid,
      webrtcextensionsid,
      queuesid,
      queues_telephone,
      profilesid,
      supervisorids,
      isSupervisor,
      teamsIds,
      ringgroupids,
      show_all_conversations,
      show_all_protocols,
      show_all_leads,
      show_all_opportunities,
      show_all_accounts,
      show_use_off_queues: !!originalUser?.show_use_off_queues,
      webrtc_auto_login,
      isAutomaticLoginQueueChat,
      redistribute_when_logout_of_queues,
      type_of_redistribution,
      typeOfRedistribution: false,
      max_chats_in_attendance,
      signatureEmail,
      isAbleToEditSlaInfoMoreThanOnce,
      shouldBeAbleToEditTheSLAInfoMoreOnlyOnce: false,
      shouldBeAbleToEditTheSLAInfoMoreThanOnce:
        !!originalUser?.isAbleToEditSlaInfoMoreThanOnce,
      queuesIdToSignInChat,
      should_sign_in_asterisk,
      queuesidToSignIn: should_sign_in_asterisk ? queuesidToSignIn : [],
      scaleId,
      use_scale: !!scaleId,
      penalties
    };

    if (originalUser?.nickname) payload.nickname = originalUser.nickname;

    return payload;
  };

  const handleCloneOpen = async (row) => {
    setOpenCloneModal(true);
    setIsFetchingCopy(true);
    setUserToCopy(null);
    try {
      const resp = await UserService.get(row.login);
      const fullUser = resp?.data?.data || row;
      setUserToCopy(fullUser);
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erro ao carregar usuário!', {
        autoClose: 3000,
        closeOnClick: true
      });
    } finally {
      setIsFetchingCopy(false);
    }
  };

  const handleCloneConfirm = async (formFromModal) => {
    try {
      setIsCloning(true);
      const payload = buildCreatePayloadFromUser(userToCopy, formFromModal);
      await UserService.create(payload);

      const fetchCreatedUser = await UserService.get(payload.login);
      const createdUser = fetchCreatedUser?.data?.data;

      const needsUpdate =
        (payload.supervisorids?.length > 0 &&
          (!createdUser?.supervisors ||
            createdUser.supervisors.length === 0)) ||
        (payload.queuesIdToSignInChat?.length > 0 &&
          (!createdUser?.queuesIdToSignInChat ||
            createdUser.queuesIdToSignInChat.length === 0));

      if (needsUpdate) {
        await UserService.update(payload.login, payload);
      }

      toast.success('Usuário clonado com sucesso!', {
        autoClose: 3000,
        closeOnClick: true
      });
      setOpenCloneModal(false);
      setUserToCopy(null);
      getUsers(activePage);

      const passwordData = {
        newPassword: formFromModal.password,
        passwordConfirmation: formFromModal.password
      };
      await UserService.changePassword(payload.login, passwordData);
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erro ao clonar usuário!', {
        autoClose: 3000,
        closeOnClick: true
      });
    } finally {
      setIsCloning(false);
    }
  };

  return (
    <>
      <MultiButtonsHeader
        setCreate={
          verifyRoles(['USERS_CREATE']) ? '/admin/user/form' : undefined
        }
        name="Form validation"
        parentName="Forms"
        buttons={renderButtonsOnHeader()}
        showArrowReturn={true}
      />
      <ManageQueuesModal
        isOpen={showQueuesModal}
        toggle={() => setShowQueuesModal(false)}
        users={usersForQueues}
        queues={queues}
        setUsersForQueues={setUsersForQueues}
      />
      <Container className="mt--6" fluid>
        <Row className="mt-3 mx-2">
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>Usuários</h3>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="8">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Insira seu nome de usuário ou login"
                          type="text"
                          value={searchUsers || ''}
                          onChange={(event) => getUsersSearch(event)}
                        />
                      </InputGroup>
                    </Col>
                    <Col md="4" className="text-right mt-2 ">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={showDisabled}
                            onChange={() => setShowDisable(!showDisabled)}
                          />
                          <span>Mostrar desabilitados</span>
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
                <ToolkitProvider
                  data={users}
                  keyField="login"
                  columns={[
                    {
                      dataField: 'name',
                      text: 'Nome',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      onSort: (column, order) => {
                        setSortField('name');
                        setSortOrder(order);
                      }
                    },
                    {
                      dataField: 'login',
                      text: 'Login',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      onSort: (column, order) => {
                        setSortField('login');
                        setSortOrder(order);
                      }
                    },
                    {
                      dataField: 'contexto.name',
                      text: 'Contexto',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      onSort: (column, order) => {
                        setSortField('contexto.name');
                        setSortOrder(order);
                      }
                    },
                    {
                      dataField: 'agent_code',
                      text: 'Código do Agente',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      onSort: (column, order) => {
                        setSortField('agent_code');
                        setSortOrder(order);
                      }
                    },
                    {
                      dataField: 'profile.name',
                      text: 'Perfil de Acesso',
                      sort: true,
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      // eslint-disable-next-line react/display-name
                      formatter: (rowContent) => {
                        return (
                          <i
                            className="fas fa-info-circle"
                            size="sm"
                            datatoggle="tooltip"
                            dataplacement="top"
                            title={rowContent}
                            datacontainer="body"
                            dataanimation="true"
                            style={{
                              fontSize: '25px',
                              color: '#2dce89',
                              cursor: 'pointer'
                            }}
                          />
                        );
                      }
                    },
                    ...(verifyRoles(['USERS_EDIT'])
                      ? [
                          {
                            dataField: 'disable',
                            style: icon_column_style,
                            headerStyle: individual_icon_header_style,
                            text: 'Habilitar / Desabilitar',
                            // eslint-disable-next-line react/display-name
                            formatter: (_, row) => {
                              return (
                                <ToggleSwitch
                                  disabled={!row.hasPermission}
                                  checked={row.active}
                                  name={row.name}
                                  id={row.login}
                                  onChange={() =>
                                    changeActive(row.login, row.active)
                                  }
                                />
                              );
                            }
                          },
                          {
                            dataField: 'edit',
                            style: icon_column_style,
                            headerStyle: individual_icon_header_style,
                            text: 'Editar',
                            // eslint-disable-next-line react/display-name
                            formatter: (rowContent, row) => {
                              return (
                                <Link
                                  style={
                                    row.hasPermission
                                      ? null
                                      : { pointerEvents: 'none' }
                                  }
                                  to={'/admin/user/form/' + row.login}
                                >
                                  <Button
                                    disabled={!row.hasPermission}
                                    color="info"
                                    size="sm"
                                  >
                                    <li className="fas fa-user-edit"></li>
                                  </Button>
                                </Link>
                              );
                            }
                          }
                        ]
                      : []),
                    ...(verifyRoles(['USERS_CREATE'])
                      ? [
                          {
                            dataField: 'clone',
                            style: icon_column_style,
                            headerStyle: individual_icon_header_style,
                            text: 'Clonar',
                            formatter: (_, row) => (
                              <Button
                                color="info"
                                size="sm"
                                title="Clonar usuário"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleCloneOpen(row);
                                }}
                                disabled={row.hasPermission === false}
                              >
                                <i className="fas fa-clone" />
                              </Button>
                            )
                          }
                        ]
                      : [])
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          selectRow={{
                            mode: 'checkbox',
                            selected: selectedRows.map((r) => r.id),
                            onSelect: handleOnSelect,
                            onSelectAll: handleOnSelectAll,
                            selectColumnStyle: select_field_row_style
                          }}
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                          sort={{
                            dataField: sortField,
                            order: sortOrder?.toLowerCase()
                          }}
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
                <ModalConfirmationCopyUser
                  isOpen={openCloneModal}
                  toggle={() => setOpenCloneModal(false)}
                  onConfirm={handleCloneConfirm}
                  isSubmitting={isCloning}
                  isLoadingOriginalUser={isFetchingCopy}
                  userToCopy={userToCopy}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default UserList;
